/**
 * Meta pixel for funnel pages (bare.liquid).
 * Loaded deferred — fires after paint, no PSI impact.
 * Product data sourced from window.__ILD_ECOM_VIEW (set by funnel-landing.liquid).
 * Independent of Littledata and Shopify Customer Events.
 */
(function () {
  var PIXEL_ID = '324207337931875';
  var _atcFired = false;

  // Standard Meta pixel base code (async, non-blocking)
  !function(f,b,e,v,n,t,s){
    if(f.fbq)return;
    n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];
    t=b.createElement(e);t.async=!0;t.src=v;
    s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s);
  }(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');

  fbq('init', PIXEL_ID);
  fbq('track', 'PageView');

  // ViewContent — fires once with product data from funnel-landing.liquid
  function fireViewContent() {
    var d = window.__ILD_ECOM_VIEW;
    if (!d) return;
    fbq('track', 'ViewContent', {
      content_ids:  [String(d.item_variant_id || d.item_id || '')],
      content_type: 'product',
      content_name: d.item_name  || '',
      value:        d.value      || 0,
      currency:     d.currency   || 'USD'
    });
  }

  // __ILD_ECOM_VIEW is set by an inline script in funnel-landing.liquid before this
  // deferred script runs, but guard with a short poll just in case.
  if (window.__ILD_ECOM_VIEW) {
    fireViewContent();
  } else {
    var _vcPoll = setInterval(function () {
      if (window.__ILD_ECOM_VIEW) {
        clearInterval(_vcPoll);
        fireViewContent();
      }
    }, 100);
    setTimeout(function () { clearInterval(_vcPoll); }, 3000);
  }

  // AddToCart — listens to cart:updated dispatched by all funnel ATC entry points
  window.addEventListener('cart:updated', function (e) {
    if (_atcFired) return;          // deduplicate within same page load
    _atcFired = true;
    setTimeout(function () { _atcFired = false; }, 2000); // reset after 2s for multi-adds
    var d = window.__ILD_ECOM_VIEW || {};
    fbq('track', 'AddToCart', {
      content_ids:  [String(d.item_variant_id || d.item_id || '')],
      content_type: 'product',
      content_name: d.item_name || '',
      value:        d.value     || 0,
      currency:     d.currency  || 'USD'
    });
  });

  // InitiateCheckout — fires when any checkout link or button is clicked
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest
      ? e.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]')
      : null;
    if (el) {
      fbq('track', 'InitiateCheckout');
    }
  }, true);

})();
